var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33329 2.91659H3.49996V4.66659H9.33329V2.91659H10.5V5.83325H11.6666V2.91659C11.6666 2.27492 11.1416 1.74992 10.5 1.74992H8.06163C7.81663 1.07325 7.17496 0.583252 6.41663 0.583252C5.65829 0.583252 5.01663 1.07325 4.77163 1.74992H2.33329C1.69163 1.74992 1.16663 2.27492 1.16663 2.91659V11.0833C1.16663 11.7249 1.69163 12.2499 2.33329 12.2499H5.24996V11.0833H2.33329V2.91659ZM6.41663 1.74992C6.73746 1.74992 6.99996 2.01242 6.99996 2.33325C6.99996 2.65409 6.73746 2.91659 6.41663 2.91659C6.09579 2.91659 5.83329 2.65409 5.83329 2.33325C5.83329 2.01242 6.09579 1.74992 6.41663 1.74992Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2583 11.0249C11.4916 10.6166 11.6666 10.1499 11.6666 9.62492C11.6666 8.16659 10.5 6.99992 9.04163 6.99992C7.58329 6.99992 6.41663 8.16659 6.41663 9.62492C6.41663 11.0833 7.58329 12.2499 9.04163 12.2499C9.56663 12.2499 10.0333 12.0749 10.4416 11.8416L12.0166 13.4166L12.8333 12.5999L11.2583 11.0249ZM9.04163 11.0833C8.22496 11.0833 7.58329 10.4416 7.58329 9.62492C7.58329 8.80825 8.22496 8.16659 9.04163 8.16659C9.85829 8.16659 10.5 8.80825 10.5 9.62492C10.5 10.4416 9.85829 11.0833 9.04163 11.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCalendar);
export default __webpack_public_path__ + "static/media/SearchCalendar.b566514d6b881b6960078ecfb08a3864.svg";
export { ForwardRef as ReactComponent };